import { TokenResponse } from "./types";

const GOOGLE_SCRIPT_SRC = "https://accounts.google.com/gsi/client";

export function loadGoogleScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${GOOGLE_SCRIPT_SRC}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = GOOGLE_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Google Identity script"));
    document.head.append(script);
  });
}

export function initializeTokenClient(
  clientId: string,
  scope: string,
  callback: (tokenResponse: TokenResponse) => void
) {
  if (!window.google?.accounts?.oauth2) {
    throw new Error("Google Identity Services not available");
  }
  return window.google.accounts.oauth2.initTokenClient({
    client_id: clientId,
    scope,
    callback
  });
}
